<template>
  <transition>
    <Modal :hideExit="true" @cancel="closeModal">
      <div id="assignment-modal">
        <div class="body" v-clickaway="close">
          <div class="header">
            <p class="typo-title1">{{ titleModal }}</p>
          </div>
          <div class="content">
            <div class="row">
              <div class="col-md-7">
                <div class="left">
                  <div class="title text-black1">
                    <p class="typo-body2">{{ searchTitle }}</p>
                  </div>
                  <div data-v-2930de00 class="search">
                    <div class="input-search ml-auto">
                      <GpInputSearch
                        class="ml-auto"
                        ref="GpRealInput"
                        :placeholder="$t('page.assignment.inputPlaceholder', { type: $tc(`page.${pType}`, 2) })"
                        @onChange="onChangeSearch"
                      />
                    </div>
                  </div>
                  <div class="list pos-relative">
                    <template v-if="loading">
                      <GLoading size="small" />
                    </template>
                    <template v-if="!loading">
                      <template v-if="filterAssigns && !filterAssigns.length">
                        <div class="list-assign-empty">
                          <p class="type-body1">
                            {{ $t("page.assignment.modal.left") }}
                            <span
                              class="text-primary"
                            >&ldquo;{{currentSearch}}&rdquo;</span>
                            {{ $t("page.assignment.modal.right") }}
                          </p>
                        </div>
                      </template>
                      <template v-else>
                        <label
                          class="list-item"
                          v-for="(item, index) in filterAssigns"
                          :key="index"
                          @click="clickItem(item)"
                        >
                          <input
                            type="checkbox"
                            name="checkbox[]"
                            :value="item.id"
                            v-model="selectedItem"
                          />
                          <span class="checkmark"></span>
                          <div class="image-item">
                            <img
                              :src="item && item.image && item.image.src ? item.image.src : 'https://ucarecdn.com/c46e919d-2c25-4095-918e-66323b559d41/-/format/auto/-/preview/3000x3000/-/quality/lighter/'"
                              alt
                            />
                          </div>
                          <div class="title">
                            <p class="typo-body1">{{ item.title }}</p>
                          </div>
                        </label>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="right">
                  <div class="title text-black1">
                    <p class="typo-body2">{{$t("banner.welcome.checklist.step2")}}</p>
                  </div>
                  <div class="select-options">
                    <div class="fake-select-option">
                      <Dropdown ref="dropdown" class bclass="select" lclass>
                        <template v-slot:button>
                          <p class="typo_body2">{{ selectedTemplate.title }}</p>
                        </template>
                        <div
                          v-for="(item, index) in filterItems"
                          :key="index"
                          class="gp_dropdown-item"
                          :class="{ 'active': selectedTemplate.id == item.id }"
                          @click="itemClick(item)"
                        >
                          <p class="typo_body2">{{ item.title }}</p>
                        </div>
                      </Dropdown>
                    </div>
                  </div>
                  <div class="description text-grey2">
                    <p
                      class="typo-tiny"
                    >{{$t("page.assignment.onceAssign", { type: $tc(`page.${pType}`, 1) })}}</p>
                  </div>
                  <!-- <div class="image-des">
                    <img
                      src="https://cdn.arstechnica.net/wp-content/uploads/2016/02/5718897981_10faa45ac3_b-640x624.jpg"
                      alt
                    />
                  </div>-->
                </div>
              </div>
            </div>
          </div>
          <div class="footer">
            <div class="btn-group flex-row-reverse">
              <button class="btn btn-primary text-grey2" @click="confirmAssign">
                <p class="typo-title2">{{$t("generals.apply")}}</p>
              </button>
              <button class="btn btn-outline text-grey2" @click="close">
                <p class="typo-title2">{{$t("generals.cancel")}}</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </transition>
</template>

<script>
import { GpInputSearch } from "@/core/shared/GpForms";
import { mapState, mapActions, mapGetters } from "vuex";
import { FETCH } from "@/utils/list.js";

let comparer = (obj, item) => {
  return obj.id === item.id;
};

export default {
  name: "AssignmentModal",
  components: {
    GpInputSearch
  },
  props: {
    pages: Array,
    type: String
  },
  data() {
    return {
      items: [],
      assigns: [],
      selectedTemplate: {},
      selectedItem: [],
      currentSearch: "",
      loading: true
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    ...mapGetters("page", {
      newestItems: "newestItems"
    }),
    pType() {
      if (!this.type) return "pages";
      let type = this.type.split("pages")[0];
      return type;
    },
    inheritObj() {
      let type = this.$tc(`page.${this.pType}`, 2);

      return {
        id: "inherit",
        title: this.$t("page.assignment.inherit", { type: type })
      };
    },

    newestItemsList() {
      return this.newestItems(this.type);
    },
    filterItems() {
      var newTemplate = [];
      for (var i = 0; i < this.items.length; i++) {
        var template = this.items[i];
        if (template.title != "Theme Product Template") {
          newTemplate.push(template);
        }
      }
      return newTemplate;
    },
    filterAssigns() {
      if (this.currentSearch) {
        return this.assigns.filter(e =>
          e.title.toLowerCase().includes(this.currentSearch.toLowerCase())
        );
      }
      return this.assigns;
    },
    titleModal() {
      return this.$t("page.assignment.modal.title", {
        type: this.$tc(`page.${this.pType}`, 1)
      });
    },
    searchTitle() {
      return this.$t("page.assignment.modal.search", {
        type: this.$tc(`page.${this.pType}`, 1)
      });
    }
  },
  watch: {
    newestItemsList: {
      deep: true,
      handler(newVal) {
        this.assigns = JSON.parse(JSON.stringify(newVal));
      }
    },
    currentSearch(newVal) {
      if (newVal == "") {
        this.assigns = JSON.parse(JSON.stringify(this.newestItems(this.type)));
      }
    }
  },
  created() {
    this.fetchItems();
    // Magic trick from Felixx
    this.items = JSON.parse(JSON.stringify(this.pages));
    this.assigns = JSON.parse(JSON.stringify(this.newestItems(this.type)));

    this.appendInherit();
    this.selectedTemplate = this.inheritObj;
  },
  methods: {
    ...mapActions("page", {
      assignTemplate: "assignTemplate",
      fetchNewestItems: "fetchNewestItems",
      searchItems: "searchItems"
    }),
    clickItem(item) {
      let template_suffix = item.template_suffix;
      if (!template_suffix) {
        this.selectedTemplate = this.inheritObj;
        return;
      }
      let template_id = 0;
      let arr = template_suffix.split("-");
      if (arr.length == 3) {
        template_id = arr[1];
      }
      let itemFound = this.items.find(e => e.id == template_id);
      if (itemFound) {
        this.selectedTemplate = itemFound;
      }
    },
    close() {
      this.$emit("close");
    },
    itemClick(page) {
      this.selectedTemplate = page;
      let $dropdown = this.$refs.dropdown;
      if ($dropdown) $dropdown.closeDropdown();
    },
    confirmAssign() {
      let selectedIDs = this.selectedItem.join(",");
      let params = {
        shop: this.shopInfo.shopifyDomain,
        type: this.type,
        templateId: this.selectedTemplate.id,
        assignId: selectedIDs
      };
      this.assignTemplate(params);
      this.$emit("close");
    },
    onChangeSearch(params) {
      try {
        const { value } = params;

        this.runnerSearch && window.clearTimeout(this.runnerSearch);
        this.runnerSearch = window.setTimeout(async () => {
          this.currentSearch = value;

          this.loading = true;
          let res = await this.searchItems({
            type: this.type,
            shop: this.shopInfo.shopifyDomain,
            query: this.currentSearch.trim()
          });
          this.loading = false;
          FETCH(
            this.assigns,
            res.data.products || res.data.collections,
            comparer,
            null
          );
        }, 400);
      } catch (err) {
        this.loading = false;
      }
    },
    appendInherit() {
      let found = this.items.find(e => e.id == "inherit");

      if (!found) {
        this.items.unshift(this.inheritObj);
      }
    },
    fetchItems() {
      this.fetchNewestItems({
        shop: this.shopInfo.shopifyDomain,
        type: this.type,
        onSuccess: () => {
          this.loading = false;
        },
        onError: () => {
          this.loading = false;
        }
      });
    },
    closeModal() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
#assignment-modal {
  position: fixed;
  border: 0;
  background: rgba(31, 31, 70, 0.3);
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  @include flex-center;
  flex-direction: column;

  .body {
    width: 800px;
    background: $neutral5;
    box-shadow: 0px 7px 64px rgba(0, 24, 46, 0.15);
    border-radius: 10px;
    padding: 25px 32px;
    min-height: 630px;

    .header {
      padding-bottom: 25px;
      border-bottom: 1px solid $grey4;
    }

    .content {
      margin-top: 25px;

      .left {
        border-right: 1px solid $grey3;
        height: 100%;

        > .title {
          margin-bottom: 10px;
        }

        .search {
          margin-right: 30px;

          .input-search {
            box-sizing: border-box;
            border-radius: 5px;
          }
          ::v-deep {
            input {
              // border: 1px solid $grey3;
              border-radius: 5px;
              &:not(:focus) {
                border-color: $grey3;
              }
            }
          }
        }

        /* Track */
        ::-webkit-scrollbar-track {
          background: none;
        }

        ::-webkit-scrollbar-thumb {
          background: $grey3;
        }

        .list {
          margin-top: 30px;
          height: 300px;
          overflow-y: auto;

          .list-assign-empty {
            position: absolute;
            width: 100%;
            height: 100%;
            padding: 70px;
            text-align: center;
          }

          /* The container */
          .list-item {
            display: flex;
            align-items: center;
            position: relative;
            cursor: pointer;
            font-size: 22px;
            user-select: none;
            padding: 9px;

            .title {
              p {
                width: 250px;
                white-space: nowrap;
                overflow: hidden !important;
                text-overflow: ellipsis;
              }
            }

            &:hover {
              background: $bg;

              .title {
                color: $cGreen;
              }
            }

            span,
            .image-item {
              margin-right: 17px;
            }

            .image-item {
              width: 42px;
              height: 42px;

              img {
                width: 100%;
                height: 100%;
              }
            }

            /* Hide the browser's default checkbox */
            input {
              position: absolute;
              opacity: 0;
              cursor: pointer;
              height: 0;
              width: 0;
            }

            /* Create a custom checkbox */
            .checkmark {
              height: 14px;
              width: 14px;
              // border-radius: 50%;
              border: 1.25px solid $grey3;

              /* Create the checkmark/indicator (hidden when not checked) */
              &:after {
                content: "";
                position: absolute;
                display: none;
              }
            }

            /* When the checkbox is checked, add a blue background */
            & input:checked {
              & ~ .checkmark {
                background-color: $cGreen;
              }

              & ~ .title {
                color: $cGreen;
              }
            }

            /* Show the checkmark when checked */
            & input:checked ~ .checkmark:after {
              display: block;
            }

            /* Style the checkmark/indicator */
            & .checkmark:after {
              left: 14px;
              top: 25px;
              width: 5px;
              height: 8px;
              border: solid white;
              border-width: 0 1px 1px 0;
              -webkit-transform: rotate(45deg);
              -ms-transform: rotate(45deg);
              transform: rotate(45deg);
            }
          }
        }
      }

      .right {
        .title {
          margin-bottom: 10px;
        }

        .select-options {
          width: 100%;

          .fake-select-option {
            ::v-deep .select {
              width: 100%;
              font-weight: inherit;
              flex-direction: row;
              justify-content: space-between;
              background: $neutral5;
              border-radius: 5px;
              border: 1px solid $grey3;
              padding-left: 16px;
              padding-right: 16px;
              &.active {
                border-color: $cPrimary;
              }
              p {
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
            }
          }
        }

        .description {
          margin-top: 10px;
        }

        .image-des {
          width: 300px;
          height: 200px;
          margin-top: 30px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .footer {
      margin-top: 35px;

      .btn-group {
        button {
          min-width: 140px;

          &:not(:last-child) {
            margin-left: 15px;
          }
        }
      }
    }
  }
}

::v-deep .gp_dropdown_list {
  max-height: 30vh;
  overflow: auto;

  .gp_dropdown-item {
    color: $black1;
    &.active {
      color: $cPrimary;
    }
  }
}
</style>
